export default "__VITE_ASSET__80JUNPnc__"